import React, { useState } from 'react';
import { Modal, Text, Button, Row, Col } from '../';
import Icons from './Icons';

const IconSelector = ({ defaultIcon, onIconSelect }) => {
  const iconsListLength = 235;
  const [currentIcon, setCurrentIcon] = useState(defaultIcon);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => setIsModalOpen(!isModalOpen);

  const handleIconChange = ({ allIcons, ind }) => {
    const selectedIcon = allIcons[ind - 1].content;
    onIconSelect(selectedIcon);
    setCurrentIcon(selectedIcon);
    toggleModal();
  };

  const clearIcon = () => {
    onIconSelect('');
    setCurrentIcon('');
    toggleModal();
  };

  return (
    <div className="d-flex flex-center-center">
      <div
        className="d-flex flex-center-center radius-sm bg-lighterGray color-white b-gray py-1 px-2 cursor-pointer"
        onClick={toggleModal}
      >
        <i
          className={`icon font-xxxlg icon-service cursor-pointer bl-gray ml-2`}
        >
          {currentIcon}
        </i>
        <Text size="sm" color>
          انتخاب آیکون
        </Text>
      </div>
      <Modal
        modalHeaderType="white"
        isOpen={isModalOpen}
        toggle={toggleModal}
        className="small-modal"
      >
        <Icons
          iconsListLength={iconsListLength}
          handleIconChange={handleIconChange}
        />

        <Row>
          <Col xs={12} className="d-flex flex-center-center">
            <Button
              className="my-3 px-2 py-1"
              text={'حذف آیکون'}
              type="secondary"
              icon="e-remove"
              iconSize="16"
              textSize="md"
              borderRadius="5px"
              onClick={clearIcon}
              disabled={!currentIcon}
            />
          </Col>
        </Row>
      </Modal>
    </div>
  );
};

export default IconSelector;
